// import $ from 'jquery';
// import 'jquery.easing';
// import videojs from 'video.js'
// import "video.js/dist/video-js.css"
// import { Header } from './components/Header.js';
// import { Contact } from './components/Contact.js';
// // import { SearchBox } from './components/SearchBox.js';
// // import { Product } from './components/Product.js';
// // import { Blog } from './components/Blog.js';
// import Slide from './components/Slide.js';
// import Swiper from 'swiper';
// import { Autoplay, EffectCreative } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/effect-creative';
// import 'swiper/css/navigation';
// import { mediaQuery, scrollTo } from './utils/functions.js';

// mediaQuery();
// const headerInstance = Header();
// Contact();

// Slide();

function requireAll(r){
  r.keys().forEach(r);
}

const pageHeader = document.querySelector('.lp25-page-wrapper .page-header');
const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
const heroSection = pageWrapper.querySelector('.hero-section');

const resizeHandler = (e)=>{
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // get x position of the footer
  // lastLookItemY = lastLookItem.getBoundingClientRect().top + window.scrollY;
  window.dispatchEvent(new Event('scroll'));
  // windowHeight = window.innerHeight;
  // heroSection.style.width = pageWrapper.offsetWidth + 'px';
}

window.addEventListener('load', resizeHandler);
window.addEventListener('resize', resizeHandler);

const timer = (func, delay)=>{
  setTimeout(()=>{
    func();
  }, delay);
}


function applyFadeIn() {
  pageWrapper.classList.remove("loaded");
  timer(() => {
    pageWrapper.classList.add("loaded");
  }, 200); // 少し遅延させて適用

}

//document.addEventListener("DOMContentLoaded", applyFadeIn);
//window.addEventListener("load", applyFadeIn);
// window.addEventListener("pageshow", function(event) {
//   if (event.persisted) {
//     applyFadeIn(); // キャッシュ復元時にも実行
//   }
// });

let st = window.scrollY;
window.addEventListener('scroll', ()=>{
  st = window.scrollY;

  // const scrollAmount = windowHeight * 2;

  if(st > 100){
    pageWrapper.classList.add('scrolled');
  } else {
    pageWrapper.classList.remove('scrolled');
  }


  // let pageHeaderY = Math.min(0, (lastLookItemY - (st)) * 0.3);

  // console.log(pageHeaderY)

  // if(lastLookItemY < st + window.innerHeight){
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // } else {
  //   pageHeader.style.transform = `${pageHeaderY}px`;
  // }

  pageHeader.style.transform = `translateX(-${scrollX}px)`;
  // let scrollX = window.scrollX;
  //heroSection.style.transform = `translateX(-${scrollX}px)`;

});

const options = {
  root: null, // ビューポートを基準にする
  rootMargin: '0px 0px -20%', // ビューポートの下から1/3 (33.33%) の位置に基準を設定
  threshold: 0 // 一部でも見えたら発火
};

const images = document.querySelectorAll(".prlx");
    

const observer = new IntersectionObserver((entries) => {

  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const image = entry.target;
      image.classList.add("executed");
      observer.unobserve(image);
    }
  });

}, options); 

images.forEach((image) => {
  observer.observe(image);
});


applyFadeIn();
// trigger scroll event
window.dispatchEvent(new Event('scroll'));


